<app-metformin
  htmlTitle="<strong>Boost</strong> Fat Loss, Energy & Metabolic Results"
  question="We strongly recommend including Metformin in your prescription. Would you like to add it to your treatment plan?"
>
  <p class="mb-4">
    Peptide therapy works best when your metabolism is optimized. If blood sugar control, insulin sensitivity, or
    inflammation are off, results can stall.
  </p>
  <p class="mb-4"><strong>Metformin helps your body use fuel more efficiently</strong>, leading to:</p>
  <ul>
    <li>Steadier energy</li>
    <li>Improved fat loss & body composition</li>
    <li>Better workout endurance</li>
    <li>Reduced inflammation</li>
  </ul>
  <br />
  <p class="mb-4">
    By improving metabolic efficiency, Metformin helps your peptides deliver
    <strong>stronger, more consistent results over time.</strong>
  </p>
  <p class="mb-4">
    Metformin is a safe, <strong>well-studied medication</strong> with decades of use and an excellent safety profile.
  </p>
</app-metformin>
